<template>

  <!-- datatable de detalle del pedido -->
  <v-data-table :headers="headers" :items="lineasEditTable" hide-actions ref="sortableTable" item-key="numeroItem">

    <template slot="items" slot-scope="props">
      <tr @click="fEditaLinea(props)" :key="fItemKey(props.item)"
        v-bind:style="{ backgroundColor: props.expanded ? activeColor : '' }">
        <td class="text-xs-left">
          <img :src="props.item.imagen" style="max-height: 80px; max-width:100px;margin-top:4px" alt="image" />
        </td>
        <td class="text-xs-left">{{ props.item.numeroItem }}</td>
        <td>
          <strong>{{ props.item.articulo }}</strong> <br>{{ props.item.nombreArticulo }}
        </td>
        <td class="text-xs-left">{{ ((props.item.nombreAgrupacion != null) && (props.item.nombreAgrupacion !== '---')) ?
          props.item.nombreAgrupacion : sinAgrupaciontxt }}</td>
        <td class="text-xs-right">{{ props.item.cantidad }} ({{ props.item.ump }})</td>
        <td class="text-xs-right">{{ props.item.cantidadUmv }} ({{ props.item.umv }})</td>
        <td class="text-xs-right">{{ props.item.volumen != null ? props.item.volumen : '-' }}</td>
        <td class="text-xs-right">{{ props.item.precioArticulo }}</td>
        <td class="text-xs-right">{{ props.item.descuento != null ? props.item.descuento : '-' }}</td>
        <td class="text-xs-right">{{ props.item.netoArticulo }}</td>
        <td class="text-xs-right">{{ props.item.importeLinea }}</td>

        <td v-on:click.stop class="justify-center layout px-0" style="margin-top: 20px;margin-bottom: 20px;">
          <v-btn flat color="green darken-1  white--text" icon class="mx-0" @click="fBorrarLinea(props.item)"
            :disabled="props.item.generadaDpc === 'S'">
            <v-icon>delete</v-icon>
          </v-btn>
        </td>

      </tr>
    </template>
    <!-- expand para el modo edicion -->
    <template slot="expand" slot-scope="props">
      <v-card flat v-bind:style="{ backgroundColor: props.expanded ? activeColorExpand : '' }">
        <v-container fluid style="padding : 25px">
          <v-form v-model="validacionEdicion" ref="form" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 sm1 class="pr-4">
                <v-text-field color="green darken-1" name="linea" :label="lineatxt" v-model="editLinea.numeroItem"
                  disabled></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 class="pr-4">
                <v-text-field color="green darken-1" name="producto" :label="productotxt"
                  v-model="editLinea.nombreArticulo" disabled></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 class="pr-4">
                <v-select color="green darken-1" :label="agrupaciontxt" autocomplete v-bind:items="itemsAgrupacion"
                  item-text="agrupaDenominacion" item-value="agrupaCodigo" v-model="editLinea.selectAgrupacion"
                  :disabled="editLinea.generadaDpc === 'S'"></v-select>
              </v-flex>
              <v-flex xs12 sm2 class="pr-4">
                <v-text-field color="green darken-1" name="referencia" :label="referenciatxt"
                  v-model="editLinea.referencia" :disabled="editLinea.generadaDpc === 'S'"></v-text-field>
              </v-flex>
              <v-flex xs12 sm1 class="pr-4">
                <v-text-field color="green darken-1" name="estado" :label="estadotxt" v-model="editLinea.estado"
                  disabled></v-text-field>
              </v-flex>
              <v-flex xs12 sm1>
                <v-text-field color="green darken-1" name="volumen" :label="volumentxt" v-model="editLinea.volumen"
                  disabled></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs1 sm1 class="pr-4">
                <v-layout row wrap>
                  <NumberTextFieldSpinner :required="true" id="editLinea.numeroItem" :label="cantidadtxt" :min="0"
                    :max="100000" :integerOnly="false" v-model="editLinea.cantidad"
                    :disabled="editLinea.generadaDpc === 'S'" />
                </v-layout>
              </v-flex>
              <v-flex xs12 sm2 class="pr-4">
                <v-select color="green darken-1" required :rules="[rules.checkCampoRequerido]" :label="tarifatxt"
                  autocomplete v-bind:items="itemsTarifa" item-text="descLarga" item-value="tarifa"
                  v-model="editLinea.selectTarifa" :disabled="editLinea.generadaDpc === 'S'"></v-select>
              </v-flex>
              <v-flex xs12 sm1 class="pr-4">
                <v-select color="green darken-1" required :rules="[rules.checkCampoRequerido]" :label="brutonetotxt"
                  autocomplete v-bind:items="itemsBrutoNeto" item-text="brutoNetoDenominacion"
                  item-value="brutoNetoCodigo" v-model="editLinea.selectBrutoNeto"
                  :disabled="disabledBrutoNeto || editLinea.generadaDpc === 'S'"></v-select>
              </v-flex>
              <v-flex xs12 sm1 class="pr-4">
                <v-text-field @keypress="fValidateInput()" required color="green darken-1" name="precio"
                  :label="preciotxt" v-model="editLinea.precioArticulo"
                  :disabled="disabledPrecio || editLinea.generadaDpc === 'S'"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 class="pr-4">
                <v-select color="green darken-1" required :label="descuentotxt" autocomplete
                  v-bind:items="itemsDescuento" item-text="denomDto" item-value="tipoDescuento"
                  v-model="editLinea.selectDescuento"
                  :disabled="disabledDescuento || editLinea.generadaDpc === 'S'"></v-select>
                <!-- modificar aqui el descuento de dentro de una linea, ahora mismo no se está pasando bien, siempre se pasa 0.-->
              </v-flex>
              <v-flex xs12 sm4>
                <v-layout row wrap>
                  <v-text-field color="green darken-1" name="dto" :label="descuentotxt" class="pr-1"
                    v-model="editLinea.porc1Dto" disabled></v-text-field>
                  <v-text-field color="green darken-1" name="mod1" label="+/-" class="pr-1" justify-center
                    v-model="editLinea.entre12" disabled></v-text-field>
                  <v-text-field color="green darken-1" name="dto2" :label="descuentotxt" class="pr-1"
                    v-model="editLinea.porc2Dto" disabled></v-text-field>
                  <v-text-field color="green darken-1" name="mod2" label="+/-" class="pr-1" justify-center
                    v-model="editLinea.entre23" disabled></v-text-field>
                  <v-text-field color="green darken-1" name="dto3" :label="descuentotxt" class="pr-1"
                    v-model="editLinea.porc3Dto" disabled></v-text-field>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12>
                <v-text-field color="green darken-1" name="observaciones" :label="observacionestxt" multi-line rows="1"
                  v-model="editLinea.observaciones" :disabled="editLinea.generadaDpc === 'S'"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm11>
              </v-flex>
              <v-flex xs12 sm1>
                <v-layout row wrap style="    margin-top: -10px;  ">
                  <v-btn color="green darken-1  white--text" value="guardar" @click="fGuardaLinea(props)"
                    :disabled="editLinea.generadaDpc === 'S'">
                    <v-icon>save</v-icon>
                    <span>{{ guardartxt }}</span>
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </template>
  </v-data-table>
</template>

<script>

import NumberTextFieldSpinner from '@/components_datadec/NumberTextFieldSpinner'

// SERVICES
import SrvPres from '@/services/srv-presupuestos'

export default {
  name: 'EditDataTable',
  props: {
    headers: {
      type: Array,
      required: true
    },
    lineas: {
      type: Array,
      required: true
    },
    fechaPedido: {
      type: String,
      required: true
    },
    moneda: {
      type: String,
      required: true
    },
    itemsAgrupacion: {
      type: Array,
      required: true
    },
    itemsDescuento: {
      type: Array,
      required: true
    }
  },
  components: {
    NumberTextFieldSpinner
  },
  data() {
    return {
      sinAgrupaciontxt: this.$t('sinAgrupacion'),
      lineatxt: this.$t('linea'),
      productotxt: this.$t('producto'),
      agrupaciontxt: this.$t('agrupacion'),
      referenciatxt: this.$t('referencia'),
      estadotxt: this.$t('estado'),
      volumentxt: 'm3',
      cantidadtxt: 'Cant.(UMP)',
      tarifatxt: this.$t('tarifa'),
      brutonetotxt: 'B/N',
      preciotxt: this.$t('precio'),
      descuentotxt: this.$t('descuento'),
      observacionestxt: this.$t('observaciones'),
      guardartxt: this.$t('guardar'),
      validacionEdicion: true,
      // disabledPrecio: this.$store.getters.getAutenticacion.tipoPresupuesto === 'JV',
      // disabledDescuento: this.$store.getters.getAutenticacion.tipoPresupuesto === 'JV',
      disabledPrecio: false,
      disabledDescuento: false,
      disabledBrutoNeto: this.$store.getters.getAutenticacion.tipoPresupuesto === 'JV',
      editLinea: {
        numeroItem: null,
        selectAgrupacion: null,
        referencia: null,
        estado: null,
        volumen: null,
        cantidadUMP: null,
        brutoNeto: null,
        tarifa: null,
        precio: null,
        tipoDescuento: null,
        porc1Dto: 0,
        porc2Dto: 0,
        porc3Dto: 0,
        entre12: '+',
        entre23: '+',
        observaciones: null
      },
      itemsTarifa: [],
      itemsBrutoNeto: [
        { brutoNetoDenominacion: this.$t('bruto'), brutoNetoCodigo: 'B' },
        { brutoNetoDenominacion: this.$t('neto'), brutoNetoCodigo: 'N' }
      ],
      itemKeys: new WeakMap(),
      currentItemKey: 0,
      selectAgrupacion: null,
      selectBrutoNeto: null,
      selectTarifa: null,
      selectDescuento: null,
      lineasEditTable: [],
      activeColor: '#EEEEEE',
      activeColorExpand: '#FAFAFA',
      rules: {
        /*
         * Regla para comprobar la forma de pago
         */
        checkCampoRequerido: (value) => {
          if ((value === undefined) || (value === null) || (value === '')) {
            return this.$t('campoRequerido')
          } else {
            return true
          }
        }
      }
    }
  },
  watch: {
    'editLinea.selectTarifa'(tarifaSelected) {
      this.itemsTarifa.forEach(itemTarifa => {
        if (itemTarifa.tarifa === tarifaSelected) {
          this.editLinea.precioArticulo = itemTarifa.precioA
          this.editLinea.selectBrutoNeto = itemTarifa.brutoNeto
          this.itemsDescuento.forEach(itemDto => {
            if (itemDto.tipoDescuento === itemTarifa.tipoDto) {
              this.editLinea.selectDescuento = itemDto
            }
          })
        }
      })
    },
    'editLinea.selectDescuento'(descuentoSelected) {
      this.fCargaDetalleDescuento(descuentoSelected)
    }
  },
  methods: {
    fCargarLineas(lineas) {
      this.lineasEditTable = lineas
    },
    /**
     * Metodo para la edicion de una linea
     */
    fEditaLinea(props) {
      let descuento = null


      // obtiene DescuentoPP del presupuesto por defecto
      for (let j = 0; j < this.itemsDescuento.length; j++) {
        if (props.item.tipoDescuento === this.itemsDescuento[j].tipoDescuento) {
          descuento = this.itemsDescuento[j]
        }
      }
      // Carga el objeto de edicion
      this.editLinea = {
        numeroItem: props.item.numeroItem,
        nombreArticulo: props.item.articulo + ' ' + props.item.nombreArticulo,
        selectAgrupacion: props.item.agrupacion,
        referencia: props.item.referencia,
        estado: props.item.estado,
        volumen: props.item.volumen,
        cantidad: props.item.cantidad,
        selectBrutoNeto: props.item.brutoNeto,
        selectTarifa: props.item.tarifa,
        precioArticulo: props.item.precioArticulo,
        observaciones: props.item.observaciones,
        generadaDpc: props.item.generadaDpc,
        selectDescuento: descuento,
        porc1Dto: 0,
        porc2Dto: 0,
        porc3Dto: 0,
        entre12: '+',
        entre23: '+'
      }
      props.expanded = !props.expanded
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        fechaTarifa: this.fechaPedido,
        unidadMedida: props.item.umv,
        articulo: props.item.articulo,
        moneda: this.moneda
      }
      SrvPres.getListaTarifas(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.itemsTarifa = response.data.tarifas
          this.itemsTarifa.map((itemTarifa, index) => {
            itemTarifa.descLarga = (itemTarifa.tipoDto !== 0) ? itemTarifa.tarifa + '   (' + itemTarifa.precioA.trim() + '€ / ' + itemTarifa.tipoDto + '%)' : itemTarifa.tarifa + '   (' + itemTarifa.precioA.trim() + '€)'
          })
        } else {
          this.$emit('alert', '<b>obtiene las tarifas</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.$emit('alert', '<b>obtiene las tarifas</b><br> ' + error.response.data.statusText)
      })
    },
    /**
     * Metodo para el borrado de una linea
     */
    fBorrarLinea(item) {
      // lanza el vento de borrao
      this.$emit('delete', item)
    },
    /**
     * Acualiza el producto
     */
    fGuardaLinea(props) {
      if (this.$refs.form.validate()) {
        let lineaActualizada = null

        if (this.lineas != null) {
          for (let i = 0; i < this.lineas.length; i++) {
            if (this.lineas[i].idLinea === props.item.idLinea) {
              lineaActualizada = Object.assign({}, this.lineas[i])

              lineaActualizada.agrupacion = this.editLinea.selectAgrupacion
              lineaActualizada.brutoNeto = (this.editLinea.selectBrutoNeto !== undefined) ? this.editLinea.selectBrutoNeto : 'N'
              lineaActualizada.tarifa = this.editLinea.selectTarifa
              lineaActualizada.fechaTarifa = this.$moment(this.fechaPedido, 'YYYY-MM-DD').format('DD/MM/YYYY')
              //lineaActualizada.tipoDescuento = this.editLinea.selectDescuento.tipoDescuento
              lineaActualizada.tipoDescuento = this.editLinea.selectDescuento

              lineaActualizada.cantidad = this.editLinea.cantidad
              lineaActualizada.precioModificado = (lineaActualizada.precioArticulo === this.editLinea.precioArticulo) ? 'N' : 'S'

              lineaActualizada.precioArticulo = parseFloat(this.editLinea.precioArticulo.toString().replace(',', '.'))
              lineaActualizada.observaciones = this.editLinea.observaciones
              lineaActualizada.referencia = this.editLinea.referencia
              lineaActualizada.accion = 'A'
              break
            }
          }
        }
        props.expanded = !props.expanded
        this.$emit('update', lineaActualizada)
      }
    },
    /**
     * Obtiene una key
     */
    fItemKey(item) {
      if (!this.itemKeys.has(item)) {
        this.currentItemKey += 1
        this.itemKeys.set(item, this.currentItemKey)
      }
      return this.itemKeys.get(item)
    },
    /**
     * Carga detalle de descuento
     */
    fCargaDetalleDescuento(descuento) {
      this.editLinea.porc1Dto = descuento.porc1Dto
      this.editLinea.porc2Dto = descuento.porc2Dto
      this.editLinea.porc3Dto = descuento.porc3Dto
      this.editLinea.entre12 = descuento.entre12
      this.editLinea.entre23 = descuento.entre23
    },
    /**
     * Valida la entrada de datos
     */
    fValidateInput(evt) {
      let returnValue = false;
      if (!evt) {
        evt = window.event
      }
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 44) {
        evt.preventDefault()
      } else {
        returnValue = true;
      }
      return returnValue;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components_datadec/EditDataTablePres.vue